// extracted by mini-css-extract-plugin
export var btnMargin = "TreatmentDetails-module--btnMargin--e16c0";
export var buttonClassName = "TreatmentDetails-module--buttonClassName--88b03";
export var buttonsContainer = "TreatmentDetails-module--buttonsContainer--41001";
export var headingContainerStyling = "TreatmentDetails-module--headingContainerStyling--54ec6";
export var treatmentCard = "TreatmentDetails-module--treatmentCard--ba261";
export var treatmentCardBigger = "TreatmentDetails-module--treatmentCardBigger--a06bf";
export var treatmentCardsContainer = "TreatmentDetails-module--treatmentCardsContainer--53206";
export var treatmentCardsContainerBigger = "TreatmentDetails-module--treatmentCardsContainerBigger--5d74a";